const React = require('react');
const { Link } = require('react-router-dom');
const { default: ListItem } = require('@mui/material/ListItem');
const { default: ListItemButton } = require('@mui/material/ListItemButton');
const { default: ListItemAvatar } = require('@mui/material/ListItemAvatar');
const { default: ListItemText } = require('@mui/material/ListItemText');
const { default: ChevronRight } = require('@mui/icons-material/ChevronRight');
const { default: Classes } = require('../../routes/app/connections/components/DirectMessagesPage/styles.scss');
const NerpyAvatar = require('./Avatar');
const { useNerpy } = require('./useNerpy');

module.exports = function NerpyConnectionsEntry() {

    const { assistant, eligible, loading } = useNerpy();

    if (!assistant && (!eligible || !loading)) {
        return null;
    }

    const name = assistant?.name || 'Nerpy';

    return <ListItem disablePadding className={Classes.nerpyConnectionEntry}>
        <ListItemButton component={Link} to='/app/nerpy' aria-label={`Chat with ${name}, companion`} className={Classes.nerpyConnectionButton}>
            <ListItemAvatar><NerpyAvatar name={name} /></ListItemAvatar>
            <ListItemText primary={`${name} — your companion`} secondary='Ask questions and find your way around with a friendly dragon-flea.' /><ChevronRight aria-hidden='true' />
        </ListItemButton>
    </ListItem>;
};
